export var DESKTOP_LOGO = {
    url: "https://res.cloudinary.com/compara/image/upload/v1705589391/assets/logos/logo_2024.svg",
    width: 120,
    height: 25,
};
export var MOBILE_LOGO = {
    url: "https://res.cloudinary.com/compara/image/upload/v1705589391/assets/logos/isologo_2024.svg",
    width: 40,
    height: 40,
};
export var IMAGE_ALT = "ComparaOnline";
export var IMAGE_MODS = ["q_auto", "f_auto"];
//# sourceMappingURL=constants.js.map